var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("validation-provider", {
        attrs: { rules: "required", name: "Peça Técnica/Geometria" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var errors = ref.errors
              return [
                _c("mapa", {
                  attrs: { geom: _vm.geom, name: "Geometria", errors: errors },
                  on: {
                    onRemoveGeometria: _vm.onRemoveGeometria,
                    atualizarGeorreferenciamento: _vm.atualizarPecaTecnica
                  },
                  model: {
                    value: _vm.geom,
                    callback: function($$v) {
                      _vm.geom = $$v
                    },
                    expression: "geom"
                  }
                }),
                _c("span", { staticClass: "help erro" }, [
                  _vm._v(_vm._s(errors[0]))
                ])
              ]
            }
          }
        ])
      }),
      _c(
        "div",
        { staticClass: "mt-1" },
        [
          _c("informacoes-area-arrecadacao", {
            attrs: {
              area: _vm.area,
              perimetro: _vm.perimetro,
              municipios: _vm.municipios
            }
          })
        ],
        1
      ),
      _vm.documentosAutenticavel
        ? _c(
            "div",
            [
              _c("app-visualizar-documentos", {
                attrs: { dadosCadastros: _vm.getDocumentosAutenticaveis() }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.documentosCadastro
        ? _c(
            "div",
            [
              _c("app-visualizar-documentos", {
                attrs: {
                  dadosCadastros: _vm.getDocumentos(),
                  showValidacaoDocumentos: _vm.showValidacaoDocumentos,
                  showDocumentosValidos: false
                },
                on: { setValidacaoDocumentos: _vm.setValidacaoDocumentos }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72bf4272", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72bf4272","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/gat/components/PecaTecnica.vue
// module id = null
// module chunks = 